import { ButtonCancel, ButtonSecondary, Colors, Icon, Text } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import type { AiPromptReplaceConfirmConfig } from '../AiPromptModal';

interface AiPromptReplaceConfirmProps {
    config: AiPromptReplaceConfirmConfig;
    onConfirm: () => void;
    onCancel: () => void;
    dataTestId: string;
}

export const AiPromptReplaceConfirm = ({
    config,
    onConfirm,
    onCancel,
    dataTestId,
}: AiPromptReplaceConfirmProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={
                'animate-fade-in-up flex flex-col items-center gap-4 rounded-2xl border border-red-200 bg-red-50/60 p-8 text-center'
            }
            data-testid={`${dataTestId}-replace-confirm`}
        >
            <div className={'flex h-12 w-12 items-center justify-center rounded-full bg-red-100'}>
                <Icon
                    name={'arrow-refresh-circle'}
                    size={'lg'}
                    color={Colors.ERROR}
                />
            </div>

            <Text
                weight={'bold'}
                className={'text-lg text-gray-800'}
            >
                {t(config.titleKey)}
            </Text>

            <Text
                color={Colors.BASE_500}
                className={'max-w-md text-base'}
            >
                {t(config.messageKey)}
            </Text>

            <Text
                weight={'semibold'}
                className={'text-gray-800'}
            >
                {t(config.questionKey)}
            </Text>

            <div className={'mt-2 flex items-center justify-center gap-3'}>
                <ButtonSecondary
                    size={'md'}
                    onClick={onCancel}
                    dataTestId={`${dataTestId}-replace-cancel`}
                >
                    {t(config.cancelKey)}
                </ButtonSecondary>

                <ButtonCancel
                    variant={'filled'}
                    size={'md'}
                    onClick={onConfirm}
                    dataTestId={`${dataTestId}-replace-confirm-button`}
                >
                    {t(config.confirmKey)}
                </ButtonCancel>
            </div>
        </div>
    );
};
